import { OUTGOING_MESSAGE } from './const';

export const messagePlatformReady = () => ({
  type: OUTGOING_MESSAGE.platformReady,
});

export const messageFrameViewReady = () => ({
  type: OUTGOING_MESSAGE.frameViewReady,
});

export const messagePlatformInfo = (content) => ({
  type: OUTGOING_MESSAGE.platformInfo,
  content,
});

export const messageSubmitInstructions = (content) => ({
  type: OUTGOING_MESSAGE.submitInstructions,
  content,
});

export const messageDisplayFullscreen = (fullscreen) => ({
  type: OUTGOING_MESSAGE.displayFullscreen,
  content: {
    fullscreen,
  },
});

export const messageCloseFrame = () => ({
  type: OUTGOING_MESSAGE.closeFrame,
});

export const messageScoreTextResult = ({ text, score, error = undefined }) => ({
  type: OUTGOING_MESSAGE.scoreTextResult,
  content: {
    text,
    score,
    error,
  },
});

export const messageDisplaySuggestionInsights = ({ generationTool, text }) => ({
  type: OUTGOING_MESSAGE.displaySuggestionInsights,
  content: {
    generationTool,
    text,
  },
});

export const messageApplySuggestion = ({ text }) => ({
  type: OUTGOING_MESSAGE.applySuggestion,
  content: {
    text,
  },
});

export const messageBrandVoiceSettings = (content) => ({
  type: OUTGOING_MESSAGE.brandVoiceSettings,
  content,
});

export const messageBrandVoiceContent = (content) => ({
  type: OUTGOING_MESSAGE.brandVoiceContent,
  content,
});
